<button
    mat-fab
    color="primary"
    class="panel-toggle"
    [ngClass]="isPanelOpen ? 'panel-open' : ''"
    aria-label="Open zoekpaneel"
    matTooltip="Open zoekpaneel"
    (click)="togglePanel()">
    <i class="fas" [ngClass]="isPanelOpen ? 'fa-xmark' : 'fa-search'"></i>
</button>

<div class="customer-details" [class.open]="isPanelOpen" (click)="$event.stopPropagation()">
    <div class="content">
        <div>
            <mat-form-field appearance="fill" class="w-100">
                <mat-label>Zoeken op kaart</mat-label>
                <input
                    matInput
                    name="search"
                    (focus)="onSearchFocus()"
                    [formControl]="fcSearch"
                    [matAutocomplete]="auto"
                    type="text" />
                <mat-autocomplete
                    #auto="matAutocomplete"
                    (optionSelected)="goToAddress($event)"
                    [displayWith]="showAddress"
                    autoActiveFirstOption
                    class="address-list">
                    @for (item of addressSearch | async; track item) {
                        <mat-option [value]="item">
                            {{ item.name }}
                        </mat-option>
                    }
                </mat-autocomplete>
            </mat-form-field>

            <div class="d-flex justify-content-between align-items-center mb-3">
                <button mat-raised-button color="primary" (click)="addArea()">Gebied toevoegen</button>
                <button
                    mat-icon-button
                    (click)="toggleMapType()"
                    class="ms-2"
                    matTooltip="Schakel tussen kaart en satelliet">
                    <i class="fas" [ngClass]="mapTypeId === 'roadmap' ? 'fa-satellite' : 'fa-map'"></i>
                </button>
            </div>
        </div>
        @for (area of areas; track area; let i = $index) {
            <div class="area">
                <div class="area-controls">
                    <h1 class="h5 condensed curpoint" (click)="editArea(area)">
                        <i class="fas fa-house-circle-check me-3"></i> {{ area.name }}
                    </h1>
                    @if (area.buildings) {
                        <small>{{ area.buildings?.length }} gebouwen</small>
                    }
                    @if (area.drawing) {
                        <div (click)="removeArea(area)" class="fab small me-1"><i class="fas fa-trash"></i></div>
                    }
                </div>
                @if (area.drawing) {
                    <div class="details">
                        <div class="d-flex justify-content-around mb-2">
                            <button
                                mat-stroked-button
                                color="primary"
                                (click)="loadAdresses(area)"
                                [disabled]="area.loading">
                                @if (!area.loading) {
                                    <i class="fa fa-file-excel me-2"></i>
                                }
                                @if (area.loading) {
                                    <i class="fa fa-spinner fa-spin me-2"></i>
                                }
                                Excel downloaden
                            </button>
                            <button
                                mat-stroked-button
                                color="primary"
                                (click)="downloadAsPdf(area)"
                                [disabled]="area.loading">
                                @if (!area.loading) {
                                    <i class="fa fa-file-pdf me-2"></i>
                                }
                                @if (area.loading) {
                                    <i class="fa fa-spinner fa-spin me-2"></i>
                                }
                                Kaart downloaden
                            </button>
                        </div>
                        <div class="row">
                            <mat-form-field appearance="fill" class="col-24">
                                <mat-label>Naam</mat-label>
                                <input
                                    [(ngModel)]="area.name"
                                    (change)="saveArea(area)"
                                    matInput
                                    name="name"
                                    placeholder="Naam van het gebied"
                                    type="text" />
                            </mat-form-field>
                        </div>
                        <div class="my-3 fst-italic">
                            Rechtermuisknop: punt toevoegen<br />
                            Gebied aanpassen: punt verslepen<br />
                            Dubbel klikken op punt: punt verwijderen
                        </div>
                    </div>
                }
            </div>
        }
    </div>
</div>

<div class="near-searchbar user-select-none">
    <div class="logo-small float-end" routerLink="/"></div>

    <google-map
        #googleMap
        height="100vh"
        [mapTypeId]="mapTypeId"
        [options]="options"
        (mapRightclick)="addPointToPolygon($event)"
        width="100%">
        @if (drawingArea) {
            @for (building of drawingArea.buildings; track building) {
                <map-marker [position]="building.locatie | latLngPosition" [icon]="'building' | mapMarker"></map-marker>
            }
            @for (ringPoint of drawingArea.exteriorRing; track ringPoint; let index = $index) {
                <map-marker
                    [position]="ringPoint | latLngPosition"
                    [label]="'' + (index + 1)"
                    [options]="{ zIndex: 999, draggable: true }"
                    [dndDraggable]="true"
                    (mapDragend)="updateLocation($event, ringPoint)"
                    (mapDblclick)="removePointFromPolygon($event)"
                    (mapClick)="removePointFromPolygon($event)"></map-marker>
            }
            @if (drawingArea.exteriorRing?.length > 3) {
                <map-polygon [paths]="drawingArea.exteriorRing" [options]="polygonOptions"></map-polygon>
            }
        }
    </google-map>
</div>
